import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  #form {
    margin: auto;
  }
`;
